// Single source of truth for the facts quoted in the legal pages.
// Empty strings are simply not displayed — fill them in once you have them
// (e.g. from your Registre du Commerce certificate and CNDP receipt).

export const company = {
  name: "Code Solutions",
  legalName: "", // e.g. "Code Solutions SARL"
  legalForm: "", // e.g. "SARL (limited liability company)"
  shareCapital: "", // e.g. "100,000 MAD"
  rcNumber: "", // Registre du Commerce, e.g. "RC Rabat 123456"
  ice: "", // Identifiant Commun de l'Entreprise
  taxId: "", // Identifiant Fiscal (IF)
  publicationDirector: "", // person responsible for the website content
  cndpReference: "", // CNDP declaration / authorization number (Law 09-08)
  address: "Rabat, Morocco",
  email: "ussefbelkhiraoui@gmail.com",
  phone: "+212 660-577967",
  phoneHref: "tel:+212660577967",
  website: "https://codesolutions.it.com",
};

export const hosting = {
  name: "Vercel Inc.",
  address: "440 N Barranca Ave #4133, Covina, CA 91723, United States",
  website: "https://vercel.com",
};

// Retention periods quoted in the Privacy Policy.
export const retention = {
  contact: "up to 3 years after our last exchange",
  chat: "up to 12 months",
};

export const LAST_UPDATED = "October 7, 2026";
